import { NgxLoggerLevel } from 'ngx-logger';

export const environment = {
    env: 'prod',
    production: true,
    encryptionSecretKey: '$Portal!nForTec@Hudson!n2021$',
    appSecretKey: '~P0rtal2Arc4AuthR3newal!n2022$-prod',
    apiUrl: 'https://forsite.fortecmedical.com/ForSiteArcPortal/api',
    notifyUrl: 'https://forsite.fortecmedical.com/ForSiteArcPortal/hub/notify',
    logLevel: NgxLoggerLevel.OFF,
    serverLogLevel: NgxLoggerLevel.OFF,
    isAuthorized: false,
};
